// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"admin-portal__SearchBox__searchBox","icon":"admin-portal__SearchBox__icon"};